import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import React from 'react'
import { ReactFC } from 'types'
import { tabsStyle } from './tabsStyle'

export const NavBarItem = styled.li<{ active: boolean }>`
  display: flex;
  align-items:center;
  margin: 0;
  list-style: none;
  & > a {
    white-space: nowrap;
    margin: 0;
    text-decoration: none;
  }

  && > a {
    color:  ${props => props.active ? "#fff" : "#999"};
  }
  ${tabsStyle}
`

export const NavigationMessage: ReactFC<{ id: string, hidden?: boolean }> = ({ id, hidden }) => {
  if (hidden) {
    return null
  }
  return <FormattedMessage id={`navigation.${id}`} />
}

export const NavBarContainer = styled.ol`
  display: flex;
  flex-direction: row;
  list-style-type: none;
  padding: 0;
  margin: 0;
  ${tabsStyle}
`